// extracted by mini-css-extract-plugin
export default {"root":"ConsumptionFilters_root__bkNqk","refreshButton":"ConsumptionFilters_refreshButton__mBDVm"};